export default __webpack_public_path__ + "static/media/a037-d.c7bc1896.jpg";